import { ChangeDetectionStrategy, Component, computed, input, InputSignal } from '@angular/core';

@Component({
    selector: 'medpace-page',
    imports: [],
    templateUrl: './page.component.html',
    styleUrl: './page.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageComponent {
    public readonly isFullHeight: InputSignal<boolean> = input(false);

    public readonly isFullWidth: InputSignal<boolean> = input(false);

    public readonly additionalClasses: InputSignal<string> = input('');

    public readonly classes = computed(() => {
        const widthClasses = this.isFullWidth() ? [] : ['container', 'px-medpace'];
        const heightClasses = this.isFullHeight() ? ['full-height', 'overflow-auto'] : ['dynamic-height', 'py-medpace'];

        return [...heightClasses, ...widthClasses].join(' ').concat(' ' + this.additionalClasses());
    });
}
